import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { ViewVoteIconsConstants } from '../../../../../../shared/constants/view-vote-icons-constants';
import { ViewVotesPopoverComponent } from '../../../../shared/components/view-votes-popover/view-votes-popover.component';
import { VotesDocumentsPopoverComponent } from '../../../../shared/components/votes-documents-popover/votes-documents-popover.component';
import { IBallotCommitteeMemberDto } from '../../../../shared/models/ballot-base/ballot-committee-member-dto';
import { IBallotVoteDto } from '../../../../shared/models/ballot-base/ballot-vote-dto';
import { CiVoteId, ciVoteOption } from '../../../../shared/models/ci/ci-vote';
import { IVotePopoverItem } from '../../../../shared/models/vote-popover-item';
import { BallotUri } from '../../../../shared/services/ballot-document.service';
import { CiBallotService } from '../../../../shared/services/ci-ballot.service';

@Component({
    selector: 'app-cib-vote-column',
    templateUrl: './cib-vote-column.component.html',
    styleUrl: './cib-vote-column.component.scss',
    standalone: false
})
export class CibVoteColumnComponent implements OnChanges, OnDestroy {

  @ViewChild('commentPopover') commentPopover!: ViewVotesPopoverComponent;
  @ViewChild('historyPopover') historyPopover!: ViewVotesPopoverComponent;
  @Input() vote: IBallotCommitteeMemberDto | null = null;
  @Input() isUserPmOrAboveOrHoSD: boolean = false;
  @Input() isUserCM: boolean = false;
  @Input() loginUserEmail: string = '';

  subscriptions: Subscription = new Subscription();
  voteCommentPopoverItems: IVotePopoverItem[] = [];
  voteHistoryPopoverItems: IVotePopoverItem[] = [];

  public readonly ViewVoteIconsConstants = ViewVoteIconsConstants;

  iconName: string = '';
  colorClass: string = '';
  hasComment: boolean = false;
  hasDocument: boolean = false;
  hasHistories: boolean = false;
  showingDocumentIcon: boolean = false;

  voteId: string = '';

  BallotType = BallotUri.CIB;

  constructor(private _ciBallotService: CiBallotService) { }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['vote']) {
      this.vote = changes['vote'].currentValue;
      if(this.vote){
        this.voteId = this.vote?.votes[0]?.id;
        const votetypeId = this.vote?.votes[0]?.voteOptionType??CiVoteId.NO_RESPONSE;
        const isEligible = this.vote?.isEligible;
        if(isEligible){
          this.checkVoteType(votetypeId as CiVoteId);
          if(this.vote){
            this.hasComment = this.checkComment(this.vote);
          }
          this.checkDocument(this.vote);
          this.checkHistories(this.vote?.votes[0]);
          this.checkUserVote(this.vote);
        }
      }
    }
  }

  checkVoteType(voteId: CiVoteId): void {
    this.iconName = ciVoteOption[voteId]?.icon;
    this.colorClass = ciVoteOption[voteId]?.color;

  }


  checkComment(vote: IBallotCommitteeMemberDto): boolean {
    if (!vote?.votes?.length) return false;
    return vote.votes.some(v => typeof v.comments === 'string' && v.comments.trim() !== '');
  }


  checkDocument(vote:IBallotCommitteeMemberDto): void{
    this.hasDocument = vote?.hasAuthDocument;
  }

  checkHistories(vote:IBallotVoteDto): void{
    if (vote?.lastUpdated && vote?.lastUpdated.toString().trim() !== '') {
      this.hasHistories = true;
    } else {
      this.hasHistories = false;
    }
  }

  checkUserVote(vote:IBallotCommitteeMemberDto) {
    if(this.isUserPmOrAboveOrHoSD) {
      this.showingDocumentIcon = this.hasDocument;
    } else if(this.isUserCM) {
      const voterEmail = vote?.email;
      if (voterEmail?.trim() && this.loginUserEmail?.trim()) {
        this.showingDocumentIcon = (voterEmail.toLowerCase() == this.loginUserEmail?.toLowerCase()) && this.hasDocument;
      } else {
        this.showingDocumentIcon = false
      }
    }
  }


  openPopover(popover: ViewVotesPopoverComponent) {
    this.getVotePopoverItems();
    popover.openPopover();
  }

  openVoteDocumentsPopover(popover: VotesDocumentsPopoverComponent) {
    popover.openPopover();
  }

  getVotePopoverItems(): void {
    this.voteCommentPopoverItems = [];
    this.voteHistoryPopoverItems = [];
    if ((this.hasComment || this.hasHistories) && this.vote && this.vote?.votes?.length > 0 ) {

      this.voteCommentPopoverItems = this.vote?.votes
        .filter((comment) => ciVoteOption[comment.voteOptionType] !== undefined && !!comment.comments && comment.comments.trim() !== '')
        .map((comment) => {

          const voteResult = ciVoteOption[comment.voteOptionType];
          const popoverItem : IVotePopoverItem = {
            voteOption: voteResult,
            additionalComments: comment.comments,
            voteSubmittedDate: comment.created
          };

          return popoverItem;
      });

      this.voteHistoryPopoverItems = this.vote?.votes
        .filter((comment) => ciVoteOption[comment.voteOptionType] !== undefined)
        .map((comment) => {
          const voteResult = ciVoteOption[comment.voteOptionType];
          const popoverItem : IVotePopoverItem = {
            voteOption: voteResult,
            voteSubmittedDate: comment.created??new Date(),
            additionalComments: null
          };

          return popoverItem;
      });

    }
  }
}

